export default {
    description:
        'Login to Activix CRM. The most innovative CRM! Easily manage your online requests, calls and walk-in and measure your performance.',
};
